import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import Icon from '../Icons/Icon';

const BackButton = ({ href, onClick, fill, size, ...rest }) => {
  const handleBackClick = (e) => {
    e.preventDefault();
    if (href) {
      window.location.href = href;
    } else if (onClick) {
      onClick();
    } else {
      window.history.go(-1);
    }
    return false;
  };

  return (
    <Button onClick={handleBackClick} classes="back-btn icon icon-M" faux {...rest}>
      <Icon name="arrow-long-left" size={size} fill={fill} />
      <span className="sr-only">Go Back</span>
    </Button>
  );
};

BackButton.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  fill: PropTypes.string,
  size: PropTypes.string,
};

export default BackButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/BackButton.js